import { IAppState } from '../../../AppModulesWrapper';
import { IPromotionService } from '../../reducers/v2';
import { selectServices } from '../../reducers/v2/promotion/selectors/selectServices';

export function selectActiveService(state: IAppState): IPromotionService | null {
  const services = selectServices(state);

  return services.find(service => service.selected) || null;
}
